import { useCallback } from 'react'
import { ethers, Contract } from 'ethers'
import { useTokenFactoryContract } from 'hooks/useContract'
import { createToken } from 'utils/calls'

const useCreateToken = ( ) => {
    const factoryContract = useTokenFactoryContract()

    const handleCreateToken = useCallback(
        async (params) => {
        return createToken(factoryContract, params )
    }, [ factoryContract ])
    return { onCreateToken: handleCreateToken }
}

export default useCreateToken